/* Size Guide is supplied by this product section; no product-page fetches. */
(() => {
  if (window.ablyeaSizeDimensionsLoaded) return;
  window.ablyeaSizeDimensionsLoaded = true;
  const selector = '.main-product .product-info .x-variant-picker fieldset[data-option-name="size"]';
  const clean = text => text.replace(/\s+/g, ' ').trim();
  const sizeKey = text => clean(text).replace(/^\d+\s*[.)]\s*/, '').replace(/[:：]\s*$/, '').toLowerCase();
  const valid = text => /\d\s*(?:["″”]|in(?:ches)?|cm)?\s*[x×]\s*\d/i.test(text);
  const cache = new WeakMap();

  function dimensions(html, sizes) {
    const document = new DOMParser().parseFromString(html, 'text/html');
    document.querySelectorAll('script,style,template').forEach(node => node.remove());
    const found = new Map();
    const set = (key, value) => {
      value = clean(value).replace(/\.$/, '');
      if (!valid(value)) return;
      // Conflicting entries must not silently select the wrong measurement.
      if (found.has(key) && found.get(key) !== value) found.set(key, '');
      else found.set(key, value);
    };
    for (const heading of document.querySelectorAll('p,h1,h2,h3,h4,h5,h6')) {
      const key = sizeKey(heading.textContent);
      if (!sizes.has(key)) continue;
      for (let next = heading.nextElementSibling; next; next = next.nextElementSibling) {
        if (next.matches('p,h1,h2,h3,h4,h5,h6') && clean(next.textContent)) break;
        const items = next.matches('li') ? [next] : Array.from(next.querySelectorAll('li'));
        for (const item of items) {
          const match = clean(item.textContent).match(/^Dimensions?\s*[:：]\s*(.+)$/i);
          if (match) set(key, match[1]);
        }
        if (found.has(key)) break;
      }
    }
    for (const row of document.querySelectorAll('tr')) {
      const cells = Array.from(row.querySelectorAll('th,td'));
      if (cells.length < 2) continue;
      const key = sizeKey(cells[0].textContent);
      if (sizes.has(key)) {
        const value = cells.slice(1).map(cell => clean(cell.textContent)).find(valid);
        if (value) set(key, value);
      }
    }
    // User-confirmed Twin XL dimensions, used only when this guide has no entry.
    if (sizes.has('twin xl') && !found.has('twin xl')) found.set('twin xl', '39" x 80"');
    return found;
  }

  function update(fieldset) {
    const data = fieldset.querySelector('[data-ablyea-size-guide]');
    if (!data) return;
    const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
    const signature = data.textContent + '\n' + inputs.map(input => input.value).join('\n');
    let record = cache.get(fieldset);
    if (!record || record.signature !== signature) {
      let html;
      try { html = JSON.parse(data.textContent); } catch (_) { return; }
      if (typeof html !== 'string') return;
      record = {signature, map: dimensions(html, new Set(inputs.map(input => sizeKey(input.value))))};
      cache.set(fieldset, record);
    }
    for (const input of inputs) {
      const label = Array.from(fieldset.querySelectorAll('label[for]')).find(node => node.htmlFor === input.id);
      if (!label || label.classList.contains('color-watches')) continue;
      const value = record.map.get(sizeKey(input.value));
      let line = label.querySelector('.ablyea-size-dimensions');
      if (!value) { line?.remove(); continue; }
      if (!line) {
        line = document.createElement('span');
        line.className = 'ablyea-size-dimensions';
        label.appendChild(line);
      }
      if (line.textContent !== value) line.textContent = value;
    }
  }
  function start() {
    let frame = 0;
    const refresh = () => { frame = 0; document.querySelectorAll(selector).forEach(update); };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(refresh); };
    refresh();
    // Variants may replace fieldsets; mutation of our own spans converges after one check.
    new MutationObserver(schedule).observe(document.getElementById('MainContent') || document.body, {childList:true,subtree:true,characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
